export { default } from './ThumbsDown'
